import { render, staticRenderFns } from "./download.vue?vue&type=template&id=48e842c2&scoped=true"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"
import style0 from "./download.vue?vue&type=style&index=0&id=48e842c2&prod&scoped=true&lang=less"
import style1 from "./download.vue?vue&type=style&index=1&id=48e842c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e842c2",
  null
  
)

export default component.exports